module.exports = __webpack_public_path__ + "img/jobs.eaaa1414.svg";